import { ReservationPlannerSessionSection } from "@/views/ReservationPlanner/types";
import { Identifiable, toId } from "./identifiable";

export const contactsPath = () => {
	return "/contacts";
};

export const reservationPlannerPath = () => {
	return `/reservations`;
};

export const newReservationPlannerSessionPath = () => {
	return `${reservationPlannerPath()}/new-session`;
};

export const reservationPlannerArchivePath = () => {
	return `${reservationPlannerPath()}/archive`;
};

export const reservationPlannerSessionPath = (
	id: Identifiable,
	section?: ReservationPlannerSessionSection
) => {
	id = toId(id);

	if (section) {
		return `${reservationPlannerPath()}/${id}/${section}`;
	}

	return `${reservationPlannerPath()}/${id}`;
};
